import React from 'react';
import $ from 'jquery';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import ServerService from '../../services/server.service';
import ReactTooltip from 'react-tooltip';

export default class Survey extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rating: 10,
            isDismiss: true,
            selectedUsability: 'Personal use',
            selectedProfession: 'Developer',
            recSelecIndustry: 'A Blog',
            industryOthers: '',
            selectedIndustries: [],
            usability: [{ key: 'Personal use', value: 'Personal use' }, { key: 'Small business (1-10)', value: 'Small business (1-10)' }, { key: 'Medium-Large Business (50+)', value: 'Medium-Large Business (50+)' }, { key: 'Decline to Answer', value: 'Decline to Answer' }, { key: 'Others', value: 'Others' }],
            professions: [{ value: 'Developer' }, { value: 'Professional' }, { value: 'Student' }, { value: 'Business/Corporation' }, { value: 'Designer' }, { value: 'Executive' }, { value: 'Decline to Answer' }, { key: 'Others', value: 'Others' }],
            industries: [{ value: 'A Blog', checked: true }, { value: 'Software Development' }, { value: 'A Commerce Platform' }, { value: 'A Service Provider' }, { value: 'Web Development' }, { value: 'Virtual Private Network' }, { value: 'Gaming Servers' }, { value: 'A Value Added Reseller' }, { value: 'Desktop As A Service' }, { value: 'Marketing' }, { value: 'A multi-cloud strategy' }, { value: 'A Database Server' }, { value: 'File Storege' }, { value: 'Backup or disaster recovery' }, { value: 'Disaster Recovery' }, { value: 'DNS' }, { value: 'Security Service' }, { value: 'Front End Web Development' }, { value: 'Decline to Answer' }, { value: 'Others' }],
            isInduOtherSelected: false
        };
    }

    componentDidMount() {
        this.checkStatus();
        this.createSlider();
        this.docMouseup();
        //this.getSurveyList();
    }

    getSurveyList() {
        ServerService.getSureyList().then(resp => {
            //console.log("survey is below: " + resp);
        });
    }

    deleteSurvey(event) {
        ServerService.deleteSurveyById().then(resp => {
            console.log("survey deleted: " + resp);
        });
        event.preventDefault();
    }

    docMouseup() {
        $(document).mouseup(function (e) {
            var container = $(".feedback_fixedBlk");
            if(!container.is(e.target) && container.has(e.target).length === 0) {
                $('.feedback_fixedBlk').removeClass("active");
            }
        });
    }

    createSlider() {
        var slider = document.getElementById('slider1');

        noUiSlider.create(slider, {
            start: 10,
            step: 1,
            connect: 'lower',
            range: {
                'min': 1,
                'max': 10
            },
            serialization: {
                format: {
                    decimals: 0
                }
            },
            pips: { mode: 'values', values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }
        });


        slider.noUiSlider.on('update', function (values, handle) {
            sessionStorage.sliderValue = Number(values[handle]);
        });
        var pips = slider.querySelectorAll('.noUi-value');
        for(var i = 0; i < pips.length; i++) {
            pips[i].style.cursor = 'pointer';
            pips[i].addEventListener('click', (event) => {
                var value = Number(event.currentTarget.dataset.value);
                slider.noUiSlider.set(value);
                this.setState({ rating: value });
            });
        }

    }

    checkStatus() {
        ServerService.isSurveyEnabled().then(resp => {
            if(resp && resp === true) {
                ServerService.getSurvey().then(resp => {
                    if(resp && resp.isHide) {
                        this.setState({ isDismiss: resp.isHide === 1 ? true : false });
                        $('.main_section').removeClass('feedback_wrap');
                    }
                    if(typeof resp === 'string' && resp === '') {
                        this.setState({ isDismiss: false });
                        $('.main_section').addClass('feedback_wrap');
                    }
                });
            }
        });
    }

    openSurveyPoup = (event) => {
        $('.feedback_fixedBlk').addClass('active');
        event.preventDefault();
    };

    openSurveyForm = (event) => {
        $('.feedbackForm').addClass('active');
        $('.feedback_fixedBlk').removeClass('active');
        var slider = document.getElementById('slider1');
        slider.noUiSlider.reset();
        this.setState({
            rating: 10,
            isInduOtherSelected: false,
            selectedUsability: 'Personal use',
            selectedProfession: 'Developer',
            feedback: '',
            industries: [{ value: 'A Blog', checked: true }, { value: 'Software Development' }, { value: 'A Commerce Platform' }, { value: 'A Service Provider' }, { value: 'Web Development' }, { value: 'Virtual Private Network' }, { value: 'Gaming Servers' }, { value: 'A Value Added Reseller' }, { value: 'Desktop As A Service' }, { value: 'Marketing' }, { value: 'A multi-cloud strategy' }, { value: 'A Database Server' }, { value: 'File Storege' }, { value: 'Backup or disaster recovery' }, { value: 'Disaster Recovery' }, { value: 'DNS' }, { value: 'Security Service' }, { value: 'Front End Web Development' }, { value: 'Decline to Answer' }, { value: 'Others' }]
        });
        event.preventDefault();
    };

    closedSurveyPoup = (event) => {
        $('.feedbackForm').removeClass('active');
        event.preventDefault();
    };

    assignRating(count, event) {
        this.setState({ rating: count + 1 });
    }

    usabilityClick(elem, event) {
        this.setState({ selectedUsability: elem.value }, () => {
            if(elem.value === 'Others') {
                $('#usabilityOthers').focus();
            }
        });
        event.preventDefault();
    }

    professionClick(elem, event) {
        this.setState({ selectedProfession: elem.value }, () => {
            if(elem.value === 'Others') {
                $('#professionOthers').focus();
            }
        });
        event.preventDefault();
    }

    industryClick(elem) {
        let selectedVal = '';
        let industries = this.state.industries;
        if(elem.checked) {
            elem.checked = false; selectedVal = '';
        } else {
            elem.checked = true; selectedVal = elem.value;
        }
        this.setState({ industries: industries, recSelecIndustry: selectedVal, isInduOtherSelected: this.isIndustryOthers() }, () => {
            if(elem.value === 'Others' && elem.checked) {
                $('#industryOthers').focus();
            }
        });
    }

    formChangeHandler = (event) => {
        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({ [name]: val, proffErrMsg: '', industryErrMsg: '', usabilityErrMsg: '' });
    };

    submitForm() {
        let selectedIndustries = [];
        this.state.industries.forEach(elem => {
            if(elem.checked && elem.value !== 'Others') selectedIndustries.push(elem.value);
        });
        if(!this.validation()) return;
        if(this.state.industryOthers && this.state.industryOthers !== '') selectedIndustries.push(this.state.industryOthers);
        let reqBody = {
            rating: sessionStorage.sliderValue,
            usability: this.state.usabilityOthers ? this.state.usabilityOthers : this.state.selectedUsability,
            industries: selectedIndustries.toString(),
            profession: this.state.professionOthers ? this.state.professionOthers : this.state.selectedProfession,
            feedback: this.state.feedback
        };
        ServerService.createSurvey(reqBody).then(resp => {
            if(resp && resp.isAxiosError) {
                this.setState({ isSuccess: false });
            }
            else {
                this.setState({ isSuccess: true, isDismiss: true });
                $('.main_section').removeClass('feedback_wrap');
            }
        });
    }

    isIndustryOthers() {
        let isOthers = false;
        this.state.industries.forEach(elem => {
            if(elem.checked && elem.value === 'Others') isOthers = true;
        });
        return isOthers;
    }

    validation() {
        if(this.state.selectedProfession === 'Others' && (this.state.professionOthers === undefined || this.state.professionOthers === '')) {
            $('#professionOthers').focus();
            this.setState({ proffErrMsg: 'Above field should not be blank.' });
            return false;
        }
        if(this.isIndustryOthers() && (this.state.industryOthers === undefined || this.state.industryOthers === '')) {
            $('#industryOthers').focus();
            this.setState({ industryErrMsg: 'Above field should not be blank.' });
            return false;
        }
        if(this.state.selectedUsability === 'Others' && (this.state.usabilityOthers === undefined || this.state.usabilityOthers === '')) {
            $('#usabilityOthers').focus();
            this.setState({ usabilityErrMsg: 'Above field should not be blank.' });
            return false;
        }

        return true;
    }

    dismiss() {
        let reqBody = {
            rating: 0
        };
        ServerService.createSurvey(reqBody).then(resp => {
            $('.feedback_fixedBlk').removeClass('active');
            this.setState({ isDismiss: true });
        });
    }


    render() {
        const surveyCss = `
        .fd0{ fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}
                        .fd1{ fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}
       `;
        return (
            <div style={ { display: this.props.isUserSubscribed ? "none" : "" } } >
                <a href="#" className="feedback_ico" onClick={ (e) => this.openSurveyPoup(e) } style={ { display: this.state.isDismiss ? 'none' : '' } }>
                    <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" style={ { enableBackground: 'new 0 0 22.7 22.7' } } xmlSpace="preserve">
                        <style type="text/css">{ surveyCss }</style>
                        <g>
                            <path className="fd0" d="M18.9,20.3H3.7c-0.8,0-1.4-0.6-1.4-1.4V3.7c0-0.8,0.6-1.4,1.4-1.4h15.2c0.8,0,1.4,0.6,1.4,1.4v15.2
                           C20.3,19.7,19.7,20.3,18.9,20.3z"></path>
                            <line className="fd1" x1="7.3" y1="7.4" x2="15.3" y2="7.4"></line>
                            <line className="fd1" x1="7.3" y1="11.4" x2="15.3" y2="11.4"></line>
                            <line className="fd1" x1="7.3" y1="15.4" x2="12.3" y2="15.4"></line>
                        </g>
                    </svg>
                </a>
                {/* <a href="#" className="feedback_ico" onClick={ (e) => this.deleteSurvey(e) } style={ { display: !this.state.isDismiss ? 'none' : '' } } title="Delete Survey">
                    <svg x="0px" y="0px" viewBox="0 0 22.7 22.7" style={ { enableBackground: 'new 0 0 22.7 22.7' } } xmlSpace="preserve">
                        <style type="text/css">{ surveyCss }</style>
                        <g>
                            <path className="fd0" d="M18.9,20.3H3.7c-0.8,0-1.4-0.6-1.4-1.4V3.7c0-0.8,0.6-1.4,1.4-1.4h15.2c0.8,0,1.4,0.6,1.4,1.4v15.2
                           C20.3,19.7,19.7,20.3,18.9,20.3z"></path>
                            <line className="fd1" x1="7.3" y1="7.4" x2="15.3" y2="7.4"></line>
                            <line className="fd1" x1="7.3" y1="11.4" x2="15.3" y2="11.4"></line>
                            <line className="fd1" x1="7.3" y1="15.4" x2="12.3" y2="15.4"></line>
                        </g>
                    </svg>
                </a> */}
                <div className="feedback_fixedBlk" >
                    <div className="feedbk_fixedPop">
                        <div className="feedbk_innerBlk">
                            <h2>How are we doing?</h2>
                            <p>Please tell us about your experience in a quick survey. Your feedback is important to us as it helps us provide a better experience for you and all our customers.</p>
                            <button className="common_cta_btn red takeSurvey" onClick={ (e) => this.openSurveyForm(e) }>Take the survey</button>
                            <span onClick={ () => this.dismiss() }>Dismiss and do not show again</span>
                        </div>
                    </div>
                </div>

                <div className="main_popup feedbackForm ">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" data-tip data-for="close-survey" title="" onClick={ (e) => this.closedSurveyPoup(e) }>
                                    <ReactTooltip id="close-survey" place="left" effect="solid"> Close</ReactTooltip>
                                </span>
                                <div className="popup_header">
                                    <div className="sub_title">Survey</div>
                                </div>
                                <div className="popup_body">
                                    <div className="feedbackForm_wrap">
                                        <div className="feedback_succesMsg" style={ { display: this.state.isSuccess ? '' : 'none' } }>
                                            <i></i>
                                            <h6>Thank You!</h6>
                                            <p>Your submission has been received</p>
                                        </div>
                                        <div className="feedbackInner_wrap" style={ { display: this.state.isSuccess ? 'none' : '' } }>
                                            <div className="notification_wrap" style={ { display: this.state.isSuccess === false ? '' : 'none' } }>
                                                <div className="msg_wrap error_notify ">
                                                    <div className="msg_wrap_inner alert">
                                                        <p className="msg_wrap_test">Unavailable, Try after sometime !</p>
                                                    </div>
                                                    <div className="msg_wrap_close" >
                                                        <a className="close_info">
                                                            <svg fill="#7293af" height="13px" width="13px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.31 13.31">
                                                                <title>close</title>
                                                                <polygon className="cls-1" points="13.31 1.82 11.49 0 6.66 4.84 1.82 0 0 1.82 4.84 6.66 0 11.49 1.82 13.31 6.66 8.47 11.49 13.31 13.31 11.49 8.47 6.66 13.31 1.82"></polygon>
                                                            </svg>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="feedback_sliderBlk">
                                                <p>How likely would you recommend our services to a friend or colleague? (1 - 10)</p>
                                                <div className="slider__container">
                                                    <div className="range_slider">
                                                        <div id="year-slider" >
                                                            {/* <div className="slider noUi-target noUi-ltr noUi-horizontal noUi-connect"><div className="noUi-base"><div className="noUi-origin noUi-background noUi-stacking" style={ { left: '77.7778%' } }><div className="noUi-handle noUi-handle-lower"></div></div></div></div>
                                                            <ul className="slider-labels eleven-columns">
                                                                { Array(10).fill(1).map((el, i) => <li key={ i } className={ this.state.rating === i + 1 ? 'active' : '' }>{ i + 1 }</li>
                                                                ) }
                                                                <li className="">1</li>
                                                                <li className="">2</li>
                                                                <li className="">3</li>
                                                                <li className="">4</li>
                                                                <li className="active">5</li>
                                                                <li className="">6</li>
                                                                <li className="">7</li>
                                                                <li className="">8</li>
                                                                <li className="">9</li>
                                                                <li className="">10</li>

                                                            </ul>*/}
                                                        </div>

                                                    </div>
                                                    <div id="slider1"></div>
                                                </div>

                                            </div>
                                            <div className="feedback_blks">
                                                <p>I'm using the IDrive<sup>®</sup> Compute platform for:</p>
                                                <div className="feedback_innerBlks">
                                                    { this.state.usability.map((elem, i) =>
                                                        <div className="custom_radioWrap" key={ i }>
                                                            <label className="custom_radioCtnr" onClick={ (e) => this.usabilityClick(elem, e) }>{ elem.value }
                                                                <input type="radio" name="feedback" value="" checked={ this.state.selectedUsability === elem.value ? 'checked' : '' } onChange={ () => this.setState({ test: true }) } />
                                                                <span className="custom_radioCheckmark"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                    }
                                                </div>
                                                <div className="common_txtBox_row" style={ { display: this.state.selectedUsability === 'Others' ? '' : 'none' } }>
                                                    <input type="text" autoComplete="off" name="usabilityOthers" className="txtBox" value={ this.state.usabilityOthers } id="usabilityOthers" onChange={ (e) => this.formChangeHandler(e) } />
                                                    <span className="err_msg" style={ { display: this.state.usabilityErrMsg ? '' : 'none' } }>{ this.state.usabilityErrMsg }</span>
                                                </div>
                                            </div>
                                            <div className="feedback_blks">
                                                <p>What industry would you best classify with?</p>
                                                <div className="feedback_innerBlks feedClassify">
                                                    { this.state.industries.map((elem, i) =>
                                                        <div className="checkbox_sec" key={ i }>
                                                            <div className="checkbox_wrap" onClick={ () => this.industryClick(elem) }>
                                                                <input type="checkbox" name="blog" className="checkbox_option" checked={ elem.checked ? 'checked' : '' } />
                                                                <label >{ elem.value }</label>
                                                            </div>
                                                        </div>
                                                    ) }
                                                </div>
                                                <div className="common_txtBox_row" style={ { display: this.state.isInduOtherSelected ? '' : 'none' } }>
                                                    <input type="text" autoComplete="off" name="industryOthers" value={ this.state.industryOthers } id="industryOthers" className="txtBox" onChange={ (e) => this.formChangeHandler(e) } />
                                                    <span className="err_msg" style={ { display: this.state.industryErrMsg ? '' : 'none' } }>{ this.state.industryErrMsg }</span>
                                                </div>
                                            </div>
                                            <div className="feedback_blks">
                                                <p>I am a</p>
                                                <div className="feedback_innerBlks vwrBlk">
                                                    { this.state.professions.map((elem, i) =>
                                                        <div className="custom_radioWrap" key={ i }>
                                                            <label className="custom_radioCtnr" onClick={ (e) => this.professionClick(elem, e) }>{ elem.value }
                                                                <input type="radio" name="feedback1" checked={ this.state.selectedProfession === elem.value ? 'checked' : '' } />
                                                                <span className="custom_radioCheckmark"></span>
                                                            </label>
                                                        </div>

                                                    ) }
                                                </div>
                                                <div className="common_txtBox_row" style={ { display: this.state.selectedProfession === 'Others' ? '' : 'none' } }>
                                                    <input type="text" autoComplete="off" name="professionOthers" className="txtBox" value={ this.state.professionOthers } onChange={ (e) => this.formChangeHandler(e) } id="professionOthers" />
                                                    <span className="err_msg" style={ { display: this.state.proffErrMsg ? '' : 'none' } }>{ this.state.proffErrMsg }</span>
                                                </div>
                                            </div>
                                            <div className="feedback_blks">
                                                <p>Any additional feedback?</p>
                                                <div className="common_txtBox_row">
                                                    <textarea autoComplete="off" name="feedback" className="txtBox" value={ this.state.feedback } onChange={ (e) => this.formChangeHandler(e) }></textarea>
                                                    <span className="err_msg" style={ { display: 'none' } }>Error msg comes here</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="popup_footer" style={ { display: this.state.isSuccess ? 'none' : '' } }>
                                    <div className="popup_footer__btns">
                                        <button className="btn blue showSuccess" onClick={ () => this.submitForm() }>Submit</button >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        );
    }
}